var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorPage',[_c('template',{slot:"Title"},[_vm._v(" Error : Page Not found ")]),_c('template',{slot:"Content"},[_vm._v(" Ooops... This page does not exist or has been removed. ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }